import PropTypes from 'prop-types';
import React from "react";
import autobind from "autobind-decorator";

export default class DropTarget extends React.Component {
    static propTypes = {
        onDrop: PropTypes.func,
        onDragEnter: PropTypes.func,
        onDragLeave: PropTypes.func,
        dropTarget: PropTypes.object,
        children: PropTypes.element
    };

    static displayName = "DropTarget";

    constructor(...props) {
        super(...props);
        this.state = {dragging: false};
        this._current = null;
    }

    getDropTarget(){
        return this.props.dropTarget || this.wrapperRef;
    }

    componentDidUpdate() {
        if (this.state.dragging) {
            this.getDropTarget().classList.add("dragging");
        } else {
            this.getDropTarget().classList.remove("dragging");
        }
    }


    componentDidMount() {
        let target = this.getDropTarget();
        target.addEventListener("drop", this.drop, false);
        target.addEventListener("drop", this.dropLeave, true);
        target.addEventListener("dragenter", this.dragEnter, false);
        target.addEventListener("dragover", this.dragOver, false);
        target.addEventListener("dragleave", this.dragLeave, false);
    }

    componentWillUnmount() {
        this.getDropTarget().classList.remove("dragging");

        let target = this.props.dropTarget;
        target.removeEventListener("dragleave", this.dragLeave, false);
        target.removeEventListener("dragover", this.dragOver, false);
        target.removeEventListener("dragenter", this.dragEnter, false);
        target.removeEventListener("drop", this.dropLeave, true);
        target.removeEventListener("drop", this.drop, false);

        this._current = null;
    }

    @autobind
    dragEnter(evt) {
        this.dragOver(evt);
        if (this._current === evt.target) {
            return;
        }

        let wasNull = this._current === null;
        this._current = evt.target;

        if (wasNull) {
            this.setState({
                "dragging": true
            });

            if (this.props.onDragEnter) {
                this.props.onDragEnter();
            }
        }
    }

    dragOver(evt) {
        evt.preventDefault();
        evt.dataTransfer.dropEffect = "copy";
    }

    @autobind
    dragLeave(evt) {
        evt.preventDefault();
        if (evt.target !== this._current) {
            return;
        }

        this._current = null;
        this.setState({
            "dragging": false
        });

        if (this.props.onDragLeave) {
            this.props.onDragLeave();
        }
    }

    @autobind
    dropLeave(evt) {
        if (this._current === null) {
            return;
        }

        this._current = null;
        this.setState({
            "dragging": false
        });

        if (this.props.onDragLeave) {
            this.props.onDragLeave();
        }
    }

    @autobind
    drop(evt) {
        evt.preventDefault();

        if (this.props.onDrop) {
            this.props.onDrop(evt.dataTransfer);
        }
    }

    render() {
        if (this.props.dropTarget){
            this.props.children;
        }

        return <div ref={el => this.wrapperRef = el}>
            {this.props.children}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/kpi/components/DropTarget.jsx